import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    creditsListRoot: {
      maxHeight: 300,
      overflowY: 'auto',
      '& .MuiListItem-root': {
        minHeight: 56,
      },
    },
    cardContentPadding: {
      padding: '24px;',
    },
    issued: {
      color: theme.palette.success.main,
      fontSize: theme.typography.pxToRem(10),
      marginRight: 5,
    },
    consumed: {
      color: theme.palette.warning.main,
      fontSize: theme.typography.pxToRem(10),
      marginRight: 5,
    },
    accountListRoot: {
      '& .MuiListItem-root': {
        padding: '5px 5px 5px 0',
      },
      '& .MuiListItemSecondaryAction-root': {
        right: 0,
      },
    },
    accountBox: {
      backgroundColor: 'rgba(244,245,247,.4)',
      borderRadius: 4,
      padding: '16px 24px',
    },
  };
});

const listTextStyles = makeStyles((theme) => {
  return {
    primary: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 'bold',
      lineHeight: 1,
    },
    secondary: {
      fontSize: theme.typography.pxToRem(112),
      lineHeight: 1,
    },
  };
});

const creditsListTextStyles = makeStyles((theme) => ({
  primary: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    color: theme.palette.secondary.dark,
    wordBreak: 'break-word',
  },

  secondary: {
    color: theme.palette.common.lightNavy,
    fontSize: theme.typography.pxToRem(13),
    wordBreak: 'break-word',
  },

  creditsUsed: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    color: theme.palette.secondary.light,
    wordBreak: 'break-word',
  },

  expDate: {
    display: 'block',
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    color: theme.palette.secondary.dark,
    wordBreak: 'break-word',
  },

  description: {
    display: 'block',
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    color: theme.palette.secondary.dark,
    wordBreak: 'break-word',
  },
}));

const listItemsStyles = makeStyles((theme) => {
  return {
    root: {
      maxWidth: '40%',
      minWidth: '50px',
      wordBreak: 'break-all',
      textAlign: 'end',
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      paddingTop: '24px',
    },
  };
});

export { useStyles, listTextStyles, listItemsStyles, customCardStyles, creditsListTextStyles };
